import axios, { AxiosRequestConfig } from "axios"
import cfg from "../config"

const createClient = (config: AxiosRequestConfig) => axios.create(config)

const defaultHeaders = {
  "Ocp-Apim-Subscription-Key": cfg.azure.apimSubscriptionKey,
  "X-MBA-API-Key": cfg.azure.mbaApiKey,
  "X-MBA-Application-ID": 'pawsall',
  "X-MBA-Application-Type": 'mypetparlorapp',
  "X-MBA-Deployment-Location": 'za1',
  "X-MBA-Client-Name": 'pawsall-website',
  "X-MBA-Client-Version": '1.0.0',
  "X-MBA-Client-Build-Number": '1',
  "X-MBA-Client-Platform": 'web',
  "Content-Type": "application/json",
}

export const getAzureApiManagementClient = () => {
  return createClient({
    baseURL: cfg.azure.apimGatewayUrl,
    headers: defaultHeaders,
  })
}
